import { component } from "picoapp";
import { type Context } from "../../state";
import { findSelectedVariants, updatePictureElement } from "../../utilities";
import { isCustomerEligibleForGwp } from "../../utilities/customer";

export const giftWithPurchase = component<Context>(async (node, context) => {
  const isProductBundle = node.dataset.isProductBundle === "true";
  const initialGiftWithPurchase =
    node.dataset.initialGiftWithPurchase === "true";
  if (isProductBundle && initialGiftWithPurchase) {
    return;
  }

  const pictureElement = node.querySelector<HTMLPictureElement>(
    "#gwp-picture picture"
  );
  const titleElement = node.querySelector<HTMLHeadingElement>(
    "#gwp-title :first-child"
  );
  const descriptionElement =
    node.querySelector<HTMLParagraphElement>("#gwp-description p");

  context.on(
    "tbsp:variant-selected",
    async ({ products = {}, selectedVariant }) => {
      const currentGiftWithPurchase = selectedVariant?.giftWithPurchase;

      if (
        currentGiftWithPurchase &&
        isCustomerEligibleForGwp(currentGiftWithPurchase) &&
        currentGiftWithPurchase.image?.url &&
        currentGiftWithPurchase.title &&
        currentGiftWithPurchase.description
      ) {
        const { description, image, title } = currentGiftWithPurchase;
        if (pictureElement) {
          updatePictureElement({
            element: pictureElement as HTMLPictureElement,
            source: image,
          });
        }

        if (titleElement && titleElement.textContent !== title) {
          titleElement.textContent = title;
        }

        if (
          descriptionElement &&
          descriptionElement.textContent !== description
        ) {
          descriptionElement.textContent = description;
        }

        node.classList.remove("hidden");
      } else {
        if (
          !findSelectedVariants(products).some(
            (selectedVariant) =>
              selectedVariant?.giftWithPurchase &&
              isCustomerEligibleForGwp(selectedVariant?.giftWithPurchase) &&
              selectedVariant?.giftWithPurchase.image?.url &&
              selectedVariant?.giftWithPurchase?.title &&
              selectedVariant?.giftWithPurchase?.description
          )
        ) {
          node.classList.add("hidden");
        }
      }
    }
  );
});
